import ProjectApi from '@/api/ProjectApi'
import { isEmpty, groupBy, keys, camelCase, forOwn, forEach } from 'lodash-es'

export const useProjectStore = defineStore({
  id: 'projectStore',
  state: () => {
    const projectState: {
      loaded: boolean
      projectDetail: any
      projectMemberList: any[]
      projectEntityList: any[]
    } = {
      loaded: false,
      projectDetail: {},
      projectMemberList: [],
      projectEntityList: []
    }
    return projectState
  },

  actions: {
    // 获取配置
    async projectInfoInit(projectId: number) {
      this.loaded = true
      const projectDetail = new Promise((resolve, reject) => {
        ProjectApi.getProjectDetail(projectId)
          .then((response) => {
            this.projectDetail = response.data
            return resolve(response.data)
          })
          .catch((e) => {
            return reject(e)
          })
      })
      const projectMemberList = new Promise((resolve, reject) => {
        ProjectApi.getProjectMemberList(projectId)
          .then((response) => {
            this.projectMemberList = response.data
            return resolve(response.data)
          })
          .catch((e) => {
            return reject(e)
          })
      })
      const projectEntityList = new Promise((resolve, reject) => {
        ProjectApi.getEntityList(projectId)
          .then((response) => {
            this.projectEntityList = response.data
            return resolve(response.data)
          })
          .catch((e) => {
            return reject(e)
          })
      })

      try {
        const requestList = [projectDetail, projectMemberList, projectEntityList]
        const response = await Promise.all(requestList)
        this.loaded = false
        return response
      } catch (error: any) {
        this.loaded = false
        return Promise.reject(error)
      }
    },
    /**
     * 获取项目详情
     * @param {number} projectId 项目id
     */
    async fetchProjectDetail(projectId: number) {
      try {
        const response = await ProjectApi.getProjectDetail(projectId)
        this.projectDetail = response.data
        return response
      } catch (error) {
        return Promise.reject(error)
      }
    },
    /**
     * 获取项目成员列表
     * @param {number} projectId 项目id
     */
    async fetchProjectMemberList(projectId: number) {
      try {
        const response = await ProjectApi.getProjectMemberList(projectId)
        this.projectMemberList = response.data
        return response
      } catch (error) {
        return Promise.reject(error)
      }
    },
    /**
     * 获取entity列表
     * @param {number} projectId 项目id
     */
    async fetchEntityList(projectId: number) {
      try {
        const response = await ProjectApi.getEntityList(projectId)
        this.projectEntityList = response.data
        return response
      } catch (error) {
        return Promise.reject(error)
      }
    }
  },
  getters: {
    entityPermission: () => {
      return (user?: any) => {
        let permission: any = {}
        if (!isEmpty(user)) {
          permission = user.permission
        }
        const groups = groupBy(keys(permission), (key: any) =>
          key.replace(/^(.*?)Erp|ViewDetail|ViewList|View|Update|Generate|Export|Review|Create|Delete$/, '$1')
        )
        const result: any = {}
        forOwn(groups, (values: any, key: any) => {
          const newKey = camelCase(key)
          const newObj: any = {}
          forEach(values, (value: any) => {
            newObj[camelCase(value.replace(key, ''))] = permission[value]
          })
          result[newKey] = newObj
        })
        return result
      }
    }
  }
})
